// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"1e7c7a93","41":"b95452f1","71":"1cf9d5af","131":"b152ab23","176":"1223fd5e","219":"12a65134","263":"76b7e3ff","301":"0b321aec","355":"f04fd341","520":"775b61dc","541":"33386af5","587":"c284c378","723":"7574c7b0","841":"71053611"}[chunkId] + ".chunk.js";
};